/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Card from './card/Card'
import useStyles from './Styles'
import { Grid, Typography, Box } from '@mui/material'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { contentType } from 'src/types/components/shared/atom'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import {
  ammbasadorCardsI,
  ambassadorCardsDescriptionI,
} from 'src/types/store/index'
import Skeleton from 'src/components/shared/modules/skeleton'
import HeadTag from 'src/components/layout/head'

interface Props {
  zenMode: boolean
  data?: any
}
function Ambassador({ zenMode, data }: Props) {
  const { classes } = useStyles()
  // const { data } = useGetPageByNameQuery('becomeAnAmbassador')
  const [header, setHeader] = React.useState<contentType>()
  const [placeholderText, setPlaceholderText] = React.useState<string>()
  const [poweredByAiText, setPoweredByAiText] = React.useState<string>()
  const [ammbasadorCards, setAmmbasadorCards] =
    React.useState<ammbasadorCardsI[]>()
  const [ambassadorCardsDescription, setAmbassadorCardsDescriptionI] =
    React.useState<ambassadorCardsDescriptionI>()

  React.useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const { heroHeader, ambassadorCardsDescription, ambassadorCards } =
        content

      if (heroHeader) {
        const {
          primaryText,
          secondaryText,
          tertiaryText,
          poweredbyaiText,
          searchPlaceholder,
        } = heroHeader
        const headerText: contentType = {
          content: {
            secondary: {
              content: secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
        }

        setHeader(headerText)
        if (searchPlaceholder) setPlaceholderText(searchPlaceholder)
        if (poweredbyaiText) setPoweredByAiText(poweredbyaiText)
      }
      if (ambassadorCardsDescription)
        setAmbassadorCardsDescriptionI(ambassadorCardsDescription)

      if (ambassadorCards) setAmmbasadorCards(ambassadorCards)
    }
  }, [data])

  return (
    <>
      <HeadTag
        title={data?.data[0].attributes.metaTitle}
        description={data?.data[0].attributes.metaDescription}
      />
      <div>
        <Box className={classes.headerWrapper}>
          {header ? (
            <HeroHeader
              searchField={false}
              endAdornment={false}
              placeHolder={placeholderText}
              poweredText={poweredByAiText}
              heroContent={header}
            />
          ) : (
            <Skeleton />
          )}
        </Box>
        <div className={classes.outerContainer}>
          <div
            className={`${classes.innerContainer} ${zenMode && classes.zenBg}`}
          >
            <Typography className={classes.title}>
              {ambassadorCardsDescription && ambassadorCardsDescription.heading}
            </Typography>
            <Typography className={classes.desc}>
              {ambassadorCardsDescription &&
                ambassadorCardsDescription.description}
            </Typography>
            <div
              className={`${classes.cardWrapper} ${zenMode && classes.zenBg}`}
            >
              <Grid container columnSpacing={6} rowSpacing={6}>
                {ammbasadorCards &&
                  ammbasadorCards.map((card, idx) => {
                    return (
                      <Grid item key={idx} md={6} lg={6}>
                        <Card content={card} zenMode={zenMode} />
                      </Grid>
                    )
                  })}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Ambassador
